import { GetConsentSubDomain } from './ConsentSubDomain';
class UrlParser {
  protected protocal: string;
  protected subdomain: string;
  protected path: string;
  protected readonly _originalPath: string;

  constructor(originalPath: string) {
    this._originalPath = originalPath;
    this.protocal = this.getProtocal();
    this.subdomain = '';
    this.path = this.getPath();
  }

  private isRelativePath() {
    return /^\//.test(this._originalPath);
  }

  private getPath() {
    const protocol = this.getProtocal();
    return this._originalPath.replace(protocol, '');
  }

  private getProtocal() {
    const regex = new RegExp('https?://');
    const hasProtocol = regex.test(this._originalPath);

    if (!hasProtocol) return '';

    return regex.exec(this._originalPath)[0] || '';
  }

  public setSubDomain(subDomain: string): UrlParser {
    if (this.isRelativePath()) return this;
    this.subdomain = !!subDomain ? `${subDomain}.` : '';
    return this;
  }

  public toUrlString(): string {
    return `${this.protocal}${this.subdomain}${this.path}`;
  }
}

class ConsentUrl extends UrlParser {
  constructor(originalPath: string) {
    super(originalPath);
    this.applyConsentSubdomain();
  }

  private applyConsentSubdomain(): void {
    this.setSubDomain(GetConsentSubDomain());
  }
}

export { UrlParser, ConsentUrl };
